<template>
  <div
    :class="wrapperClasses"
  >
    <p
      :class="labelClasses"
      @click.prevent="toggleElement"
      :title="toggleTitle"
    >
      <span>
        {{ label }}
        <span
          v-if="labelExtra"
          class="italic text-xxs"
        >
          {{ labelExtra }}
        </span>
      </span>

      <span
        class="inline-flex items-center"
        :title="toggleTitle"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        v-if="info"
        v-tooltip="{'theme':'dropdown', 'content':info, 'trigger':'click', 'placement':'top-end'}"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <svg
          v-if="isOpen"
          xmlns="http://www.w3.org/2000/svg"
          class="w-5 h-5 text-gray-400 group-hover:text-white"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
        </svg>
        <svg
          v-else
          class="w-5 h-5 text-gray-300 group-hover:text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg>
      </span>
    </p>
    <div
      v-show="isOpen"
      :class="contentClasses"
    >
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    startOpen: {
      type: Boolean,
      required: false,
      default: false,
    },
    wrapperClasses: {
      type: String,
      default: 'p-4 xl:py-6 xl:px-8',
    },
    label: {
      type: String,
      required: true,
    },
    labelExtra: {
      type: String,
      required: false,
    },
    labelClasses: {
      type: String,
      default: 'flex justify-between ml-4 cursor-pointer group text-sm font-semibold leading-4 text-gray-200 md:text-base md:ml-0',
    },
    contentClasses: {
      type: String,
      default: 'mt-2',
    },
    info: {
      type: String,
      required: false, 
    }
  },
  data: () => ({
    isOpen: false,
  }),
  methods: {
    toggleElement() {
      this.isOpen = !this.isOpen;
    },
    setDefaultBehavior() {
      this.isOpen = this.startOpen;
    },
  },
  computed: {
    toggleTitle() {
      if(this.isOpen) {
        return "Collapse";
      }
      return "Expand";
    },
  },
  mounted() {
    this.setDefaultBehavior();
  },
};

</script>
